import villaImage from "../../Images/Resort.png";
import TravelEnquiryPage from "./TravelEnquiryPage";

const VillasPage = () => (
  <TravelEnquiryPage
    eyebrow="A stay of your own"
    title="Find a villa for your getaway"
    description="Planning a private escape with family or friends? Tell us where you would like to go, when you plan to travel, and what kind of stay you have in mind. Our team can help you enquire about suitable villa options."
    image={villaImage}
    imageAlt="Villa with a private pool in a tropical setting"
    highlights={[
      "Ask about options for your destination and dates",
      "Share your group size and preferred amenities",
      "Confirm availability and details directly with our team",
    ]}
    enquiryMessage="Enquire about villas"
  />
);

export default VillasPage;
